import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External actions
 */
import { actions as teamMembersActions } from 'sagas/app/companies/fetchTeamMembersSaga';

/**
 * Constants
 */
export const REQUEST = '@app/company/order/team/notify/toggle/REQUEST';
export const SUCCESS = '@app/company/order/team/notify/toggle/SUCCESS';
export const FAILURE = '@app/company/order/team/notify/toggle/FAILURE';
export const CLEAR = '@app/company/order/team/notify/toggle/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    error: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.error = '';
                break;
            case SUCCESS:
                draft.loading = false;
                break;
            case FAILURE:
                draft.loading = false;
                draft.error = payload;
                break;
            case CLEAR:
                draft.loading = false;
                draft.error = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Saga functions
 */
export const sagas = {
    *request({ payload }) {
        try {
            const { company_id, id, order_confirmation } = payload;
            const response = yield axios.post(
                `/companies/users/settings/order-confirmation/${id}`,
                { company_id, order_confirmation }
            );

            yield put(actions.success());

            yield put(teamMembersActions.update(response.data.data));
        } catch (e) {
            yield put(actions.failure(errorMessageGenerator(e)));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
